
import { defineComponent } from 'vue'
import TextLink from '@/components/elements/TextLink.vue'

export default defineComponent({
  name: 'EventPrecautionForJoin',
  components: {
    TextLink
  },
  props: {
    precautionHtml: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    return {
      hasHtml: props.precautionHtml !== ''
    }
  }
})
